import { Component, OnInit, Input } from '@angular/core';
import { NewsService } from '../news/news.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ShareButtons } from '@ngx-share/core';
// import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { NguCarousel } from '@ngu/carousel';

@Component({
  selector: 'app-single-news',
  templateUrl: './single-news.component.html',
  styleUrls: ['./single-news.component.scss']
})

export class SingleNewsComponent implements OnInit {
  @Input() actu;

  public carouselNews: NguCarousel;

  // public configSwiper: SwiperConfigInterface = {
  //   direction: 'horizontal',
  //   slidesPerView: 1,
  //   keyboard: true,
  //   mousewheel: false,
  //   scrollbar: false,
  //   navigation: false,
  //   pagination: true,
  //   effect: 'fade',
  //   spaceBetween: 300,
  //   loop: true,
  //   // autoHeight: true
  // };
  //
  // private pagination: SwiperPaginationInterface = {
  //   el: '.swiper-pagination',
  //   clickable: true,
  //   hideOnClick: false
  // };

  constructor(
    private newsService: NewsService,
    private route: ActivatedRoute,
    private location: Location,
    public share: ShareButtons

  ) { }

  ngOnInit() {
    this.getActu();

    this.carouselNews = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true,
        pointStyles: `
        .ngucarouselPoint {
          list-style-type: none;
          text-align: center;
          padding: 12px;
          margin: 0;
          white-space: nowrap;
          overflow: auto;
          width: 100%;
          left: 0;
          box-sizing: border-box;
        }
        .ngucarouselPoint li {
          display: inline-block;
          border-radius: 999px;
          background: #d4d4d4;
          padding: 5px;
          margin: 0 3px;
          transition: .4s ease all;
        }
        .ngucarouselPoint li:hover {
          cursor:pointer;
        }
        .ngucarouselPoint li.active {
          background: #7c02af;
          width: 10px;
        }
        `
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    };
  }

  getActu(): void {
    const slug = this.route.snapshot.paramMap.get('slug');

    this.newsService.getActu(slug)
    .subscribe(
      data => { this.actu = data[0]; },
      err => console.error(err),
      () => console.log(this.actu.acf.slides.length)
    );
  }

  public myfunc(event: Event) {
    // carouselLoad will trigger this funnction when your load value reaches
    // it is helps to load the data by parts to increase the performance of the app
    // must use feature to all carousel
  }

}



// WEBPACK FOOTER //
// ./src/app/single-news/single-news.component.ts